export const groupChatEditorEn = {
  createChat: 'Create a chat',
  listOfChatParticipants: 'List of chat participants',
  editingGroupChat: 'Editing a group chat',
  warning:
    'To create a group chat, you must select at least one user, and specify a name'
}

export const groupChatEditorRu: typeof groupChatEditorEn = {
  createChat: 'Создать чат',
  listOfChatParticipants: 'Список участников чата',
  editingGroupChat: 'Редактирование группового чата',
  warning:
    'Чтобы создать групповой чат, необходимо выбрать как минимум одного пользователя, и указать название'
}
